<style lang="scss" src='./opUsersReport.scss' scoped></style>
<template src="./opUsersReport.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import GwExport from '@/components/gwExport/GwExport.vue';
import ApexChart from 'vue-apexcharts';
import VueHtml2pdf from 'vue-html2pdf';
import moment from 'moment';

import {
    getAllUsers
} from '@/api/index';

import i18n from './../../../../i18n';

let CounterForUpdatesCol = 0;
let CounterForUpdatesStack = 0; 
let CounterForUpdatesPie = 0;
let alertsArray = [];

const perPage = 100;
const pdfMaxWidth = 1120;
const chartWidth12 = "1050px";
const chartWidth6 = "500px";
const chartWidth4 = "350px";

export default {
    name: 'OpUsersReport',
    extends: SecurityComponent,
    components: {
        ApexChart,
        VueHtml2pdf,
        GwExport
    },
    data() {
        return {
            chartMaxWidth12: '100%',
            chartMaxWidth6: '100%',
            chartMaxWidth4: '100%',
            stickyData: true,
            pdfName: null,
            loading: false,
            filters: {
                daysBack: null,
                threshold: null,
            },
            alerts: [],
            usersLength: 0,
            column_series: [],
            column_x_cats: [],
            stack_series: [],
            stack_x_cats: [],
            pie_series: [],
            pie_cats: [],
            user_types: [],
            user_times: [],
            types_amounts: {},
            times_amounts: {},
            options: [
                { text: this.$t('timePeriods.1D'), label: this.$t('timePeriods.last24H'), value: 1, },
                { text: this.$t('timePeriods.2D'), label: this.$t('timePeriods.last2D'), value: 2, },
                { text: this.$t('timePeriods.1W'), label: this.$t('timePeriods.lastWeek'), value: 7, },
                { text: this.$t('timePeriods.1M'), label: this.$t('timePeriods.lastMonth'), value: 30, },
                { text: this.$t('timePeriods.1Y'), label: this.$t('timePeriods.lastYear'), value: 365, },
            ],
            basicColCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            stackedColCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            pieCharOpt: {
            },
            pagination: {
                page: 1,
                start: 0,
                end: 0
            },
            pdf: {},
        };
    },
    computed: {
        getUsers() {
            return this.alerts;
        },
        canGetNextPage(){
            return this.pagination.page * perPage < this.usersLength;
        }
    },
    methods: {
        getCsvData(){
            if(alertsArray.length>0){
                let data = alertsArray.map((item)=>{
                    let obj = {}
                    obj[i18n.t('general.name')] = item.name;
                    obj[i18n.t('user.lastName')] = item.last_name;
                    obj[i18n.t('user.role')] = item.user_type.name;
                    obj[i18n.t('user.email')] = item.email;
                    obj[i18n.t('user.username')] = item.username;
                    obj[i18n.t('user.phone')] = item.phone;
                    obj[i18n.t('general.creationDate')] = this.G_formatDate({date: (item.time_created), pretty: false});
                    return obj
                })
                return data;
            }
            return [];
        },

        showNextPage(){
            if(this.canGetNextPage){
                this.pagination.page += 1;
                this.pagination.start += perPage;
                let newEnd = this.pagination.end + perPage;
                this.pagination.end = (this.usersLength >= newEnd) ? newEnd : this.usersLength;
            }
            this.getAlertsByPage();
        },
        
        showPrevPage(){
            if(this.pagination.page > 1){
                this.pagination.page -= 1;
                this.pagination.start -= perPage;
                this.pagination.end = this.pagination.start + perPage - 1;
            }
            this.getAlertsByPage();
        },

        getAlertsByPage(){
            this.alerts = alertsArray.slice(this.pagination.start - 1, this.pagination.end);
        },

        resetValues() {
            alertsArray = [];
            this.alerts = [];
            this.usersLength = 0;
            this.column_series = [];
            this.column_x_cats = [];
            this.stack_series = [];
            this.stack_x_cats = [];
            this.pie_series = [];
            this.user_types = [];
            this.user_times = [];
            this.pie_cats = [];
            this.types_amounts = {};
            this.times_amounts = {};
            this.pagination= {
                page: 1,
                next: false
            }
        },
        
        exportReport(item){
            this.$refs.stationAlertPDF.generatePdf();
        },

        loadData() {
            this.loading = true;
            this.getGraph();
        },

        async getGraph(){
            let tempChartOptions = this.getBasicColumnChartOptions();
            let tempStackChartOptions = this.getStackedColumnsChartOptions();
            let tempPieChartOptions = this.getPieChartOptions();

            const data = {
                courseId: this.$store.state.course.course_id,
                until: this.filters.daysBack.value,
                resampleFreq: this.filters.daysBack.value == 365 ? '8h' : null
            };

            let apiCall = getAllUsers;
            
            await apiCall(data).then((res) => {
                this.usersLength = res.users.length;
                if (res.users.length > 0) {
                    alertsArray = res.users;
                    this.pagination.start = 1;
                    this.pagination.end = (this.usersLength >= perPage) ? perPage : this.usersLength;
                    this.getAlertsByPage();
                }
                
                if (res.users.length > 0){
                    for (var i = 0; i < res.users.length; i++) {
                        let find = this.user_types.find((type)=> type == res.users[i].user_type.name);

                        if(!find){
                            this.user_types.push(res.users[i].user_type.name);
                            this.types_amounts[res.users[i].user_type.name] = 1;
                        }else{
                            this.types_amounts[res.users[i].user_type.name] += 1;
                        }
                        
                        let date = moment(res.users[i].time_created).format("MM-DD-YYYY");
                        let findTime = this.user_times.find((d)=> d == date);

                        if(!findTime){
                            this.user_times.push(date);
                            this.times_amounts[date] = 1;
                        }else{
                            this.times_amounts[date] += 1;
                        }
                    }

                    let label = [];
                    for (var i = 0; i < this.user_types.length; i++) {
                        this.pie_series.push(this.types_amounts[this.user_types[i]]);
                        label.push(this.getLbl(this.user_types[i]));
                    }

                    tempPieChartOptions.labels = label;
                }

                this.pieCharOpt = tempPieChartOptions;

                if (this.user_times.length > 0){
                    let byTimeData = {};
                    let name = i18n.t('users.users');

                    for (var i = 0; i < this.user_times.length; i++){
                        let dateKey = '';
                        dateKey = this.user_times[i] + ' UTC';
                        let myArray = [];
                        myArray[name] =  this.times_amounts[this.user_times[i]];
                        if (!(dateKey in byTimeData)){
                            byTimeData[dateKey] = {...myArray};
                        }
                    }

                    let tempSeries = {}
                    for (const [key, value] of Object.entries(byTimeData)) {
                        this.column_x_cats.push(key);
                        
                        for (const [k, v] of Object.entries(value)) {
                            if (!(k in tempSeries)){
                                tempSeries[k] = [];
                            }
                            tempSeries[k].push(v);
                        }
                    }

                    for(const [key, value] of Object.entries(tempSeries)){
                        let name = i18n.t('users.users');
                        this.column_series.push({'name': key, 'data': value})
                    }

                    tempChartOptions.xaxis.categories = this.column_x_cats;
                }

                this.basicColCharOpt = tempChartOptions;

                if(this.user_types.length > 0){
                    let bySensorData = {};

                    for (var i = 0; i < this.user_types.length; i++){
                        
                        let locationKey = this.user_types[i];

                        if (!(locationKey in bySensorData)){
                            bySensorData[locationKey] = {...this.types_amounts};
                        }

                            bySensorData[locationKey] += parseInt(12);
                            //bySensorData[locationKey][res.users[i].user_type.name] += parseInt(res.by_station[i].amount);
                    }

                    let tempSeries = {}
                    for (const [key, value] of Object.entries(bySensorData)) {
                        this.stack_x_cats.push(key);

                        for (const [k, v] of Object.entries(value)) {
                            if (!(k in tempSeries)){
                                tempSeries[k] = [];
                            }
                            tempSeries[k].push(v);
                        }
                    }

                    for(const [key, value] of Object.entries(tempSeries)){
                        let i18n_key = "users.users";
                        let name = (i18n_key != undefined && i18n_key != null) ? i18n.t(i18n_key) : key;
                        
                        this.stack_series.push({'name': name, 'data': value})
                    }
                }           
            });
            this.loading = false;
        },

        getLbl(tag) {
            switch(tag){
                case "Admin":
                    return i18n.t("users.role_1");
                case "Operations":
                    return i18n.t("users.role_2");
                case "GroundWorx Agent":
                    return i18n.t("users.role_3");
                case "Superintendent":
                    return i18n.t("users.role_4");
                case "Foreman":
                    return i18n.t("users.role_5");
                case "Staff":
                    return i18n.t("users.role_6");
                case "Manager":
                    return i18n.t("users.role_7");
                case "Manufacturer":
                    return i18n.t("users.role_8");
                case "Prospect":
                    return i18n.t("users.role_9");
                case "Guest":
                    return i18n.t("users.role_10");
                case "GroundWorx":
                    return i18n.t("users.role_11");
                case "Assistant Superintendent":
                    return i18n.t("users.role_12");
                case "Director of Agronomy":
                    return i18n.t("users.role_13");
                case "General Manager":
                    return i18n.t("users.role_14");
                case "Course Operations":
                    return i18n.t("users.role_15");
                case "Director of Golf":
                    return i18n.t("users.role_16");
                case "Club Professional":
                    return i18n.t("users.role_17");
                case "Club Manager":
                    return i18n.t("users.role_18");
                case "Greenskeeper":
                    return i18n.t("users.role_19");
                case "SVP of Agronomy":
                    return i18n.t("users.role_20");
                case "Heads Groundsman":
                    return i18n.t("users.role_21");
                case "Assistant Heads Groundman":
                    return i18n.t("users.role_22");
                case "Head Grounds Person":
                    return i18n.t("users.role_23");
                case "Assistant Head Grounds Person":
                    return i18n.t("users.role_24");
                case "Grounds Supervisor":
                    return i18n.t("users.role_25");
                case "Parks Supervisor":
                    return i18n.t("users.role_26");
                case "Parks Superintendent":
                    return i18n.t("users.role_27");
                case "Sports Turf Manager":
                    return i18n.t("users.role_28");
                case "Director of Athletic Facilities":
                    return i18n.t("users.role_29");
                case "Landscape Supervisor":
                    return i18n.t("users.role_30");
                case "Director of Water Management":
                    return i18n.t("users.role_31");
                case "Water Manager":
                    return i18n.t("users.role_32");
                case "Irrigation Specialist":
                    return i18n.t("users.role_33");
                case "Grounds Manager":
                    return i18n.t("users.role_34");
                case "Lean Groundsman":
                    return i18n.t("users.role_35");
                case "CEO":
                    return i18n.t("users.role_36");
                case "Research Agronomist":
                    return i18n.t("users.role_37");
                default :
                    return i18n.t("users.users");
            }
        },

        getBasicColumnChartOptions() {
            return {
                chart: {
                    type: 'line',
                    animations: {
                        enabled: false,
                    },

                    height: 350,
                    zoom: {
                        type: 'x',
                        enabled: false,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        show: false
                    },
                    events: {
                        updated: function (chartContext, config) {
                            if (CounterForUpdatesCol != 0) {
                                var elmnt = document.getElementById("column_chart");
                                if (elmnt) {
                                    elmnt.scrollIntoView();
                                }
                            }
                            ++CounterForUpdatesCol;
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                title: {
                    text: '',
                    align: 'left'
                },
                fill: {
                    opacity: 1,
                },
                stroke: {
                    show: true,
                    width: 3
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            return val ? (val < 5 ? (val).toFixed(1) : Math.round(val)) : 0;
                        },
                    },
                    title: {
                        text: ''
                    },
                    min: 0
                },
                xaxis: {
                    type: 'datetime',
                    labels: {
                        datetimeUTC: false,
                        datetimeFormatter: {
                            year: 'yyyy',
                            month: "MMM 'yy",
                            day: 'dd MMM',
                            hour: 'h:mm TT',
                        },
                    },
                },
                tooltip: {
                    x: {
                        show: true,
                        formatter: (val) => {
                            return this.G_formatDate({date: val, pretty: false});
                        }
                    },
                    shared: false,
                    y: {
                        formatter: (val) => {
                            return val ? val : 0;
                        }
                    }
                }
            }
        },

        getStackedColumnsChartOptions(){
            return {
                chart: {
                    type: 'bar',
                    animations: {
                        enabled: false,
                    },
                    stacked: true,

                    height: 350,
                    zoom: {
                        type: 'x',
                        enabled: false,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        show: false
                    },
                    events: {
                        updated: function (chartContext, config) {
                            if (CounterForUpdatesStack != 0) {
                                var elmnt = document.getElementById("stacked_chart");
                                if (elmnt) {
                                    elmnt.scrollIntoView();
                                }
                            }
                            ++CounterForUpdatesStack;
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                title: {
                    text: '',
                    align: 'left'
                },
                fill: {
                    opacity: 1,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '50%'
                    },
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            return val ? (val < 5 ? (val).toFixed(1) : Math.round(val)) : 0;
                        },
                    },
                    title: {
                        text: ''
                    },
                    min: 0
                },
                xaxis: {
                    type: 'category',
                },
                tooltip: {
                    x: {
                        show: true,
                        formatter: (val) => {
                            return val;
                        }
                    },
                    shared: false,
                    y: {
                        formatter: (val) => {
                            return val ? val : 0;
                        }
                    }
                },
            }
        },

        getPieChartOptions(){
            return {
                chart: {
                    type: 'pie',
                    animations: {
                        enabled: false,
                    },
                    height: 350,
                    zoom: {
                        type: 'x',
                        enabled: false,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        show: false
                    },
                    events: {
                        updated: function (chartContext, config) {
                            if (CounterForUpdatesPie != 0) {
                                var elmnt = document.getElementById("pie_chart");
                                if (elmnt) {
                                    elmnt.scrollIntoView();
                                }
                            }
                            ++CounterForUpdatesPie;
                        }
                    }
                },
                dataLabels: {
                    enabled: true
                },
                title: {
                    text: '',
                    align: 'left'
                },
                fill: {
                    opacity: 1,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                legend: {
                    position: 'bottom'
                },
                colors:  [
                    '#C0392B', '#9B59B6', '#3498DB', 
                    '#16A085', '#2ECC71', '#F7DC6F', 
                    '#F39C12', '#784212', '#34495E', 
                    '#B3B6B7', '#0B5345', '#a259a4',
                    "#f812b3", "#b17fc9", "#8d6c2f"]
            }
        },

        async beforePDF({ html2pdf, options, pdfContent }){
            let container = this.$refs.reportContainer;
            let currentWidth = container.getBoundingClientRect().width;

            if(currentWidth >= pdfMaxWidth){
                this.chartMaxWidth12 = chartWidth12;
                this.chartMaxWidth6 = chartWidth6;
                this.chartMaxWidth4 = chartWidth4;
            }

            let date = new Date();
            this.pdf.date = moment(date).format("MM-DD-YYYY");
            
            this.stickyData = false;

            await html2pdf().set(options).from(pdfContent).toPdf().save();

            this.chartMaxWidth12 = "100%";
            this.chartMaxWidth6 = "100%";
            this.chartMaxWidth4 = "100%";
            this.stickyData = true;
        },

    },

    created() {
        let date = new Date();
        date = moment(date).format("MM-DD-YYYY");
        this.pdfName = i18n.t('users.users') + ' ' + date;
    },

    async mounted() {
        alertsArray = [];
        this.filters.daysBack = this.options[0];
        this.loadData();
    },
};

</script>
